import addOnsJson from '@/i18n/en/addOns.json'
import categoryContentJson from '@/i18n/en/category_content.json'
import citizenFamilyJson from '@/i18n/en/citizen_family.json'
import establishmentJson from '@/i18n/en/establishment.json'
import footerJson from '@/i18n/en/footer.json'
import homeJson from '@/i18n/en/home.json'
import individualDashboard from '@/i18n/en/individual_dashboard.json'
import individualResidency from '@/i18n/en/individual_residency.json'
import loginJson from '@/i18n/en/login.json'
import loginHistory from '@/i18n/en/login_history.json'
import mostVisitedJson from '@/i18n/en/most_visited.json'
import registrationJson from '@/i18n/en/registration.json'
import requestJson from '@/i18n/en/request.json'
import scanDocJson from '@/i18n/en/scanDoc.json'
import settingsJson from '@/i18n/en/settings.json'
import sharedJson from '@/i18n/en/shared.json'
import subscriptionServiceDetailsJson from '@/i18n/en/subscription_service_details.json'
import typingCentersJson from '@/i18n/en/typing_centers.json'
import userProfileJson from '@/i18n/en/userProfile.json'
import validationJson from '@/i18n/en/validation.json'
import paymentsJson from '@/i18n/en/payments.json'

export default {
  ...requestJson,
  ...categoryContentJson,
  ...addOnsJson,
  ...loginJson,
  ...sharedJson,
  ...footerJson,
  ...mostVisitedJson,
  ...settingsJson,
  ...validationJson,
  ...registrationJson,
  ...citizenFamilyJson,
  ...subscriptionServiceDetailsJson,
  ...loginHistory,
  ...individualDashboard,
  ...establishmentJson,
  ...userProfileJson,
  ...homeJson,
  ...typingCentersJson,
  ...scanDocJson,
  ...individualResidency,
  ...paymentsJson
}
